module.exports = __webpack_public_path__ + "static/media/Grafie.a8fff390.png";